import Repository from "../../repository";

export default {
    GetActionList: (payload) => Repository.post(`/api/CabinetActions/GetActionList`, payload),
    CabinetAction: (payload) => Repository.post(`/api/CabinetActions/CabinetAction`, payload),
    EditSchedule: (payload) => Repository.post(`/api/CabinetActions/EditSchedule`, payload),
    LampAction: (payload) => Repository.post(`/api/CabinetActions/LampAction`, payload),
    GetLampAction: (payload) => Repository.post(`/api/CabinetActions/GetLampAction`, payload),
}
